var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "goods_drawer_basic_padding" }, [
    _c(
      "div",
      {
        staticClass: "goods_drawer_basic",
        style: { backgroundColor: _vm.value.config.bg_color || "#fff" },
      },
      [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.value.config.name)),
          ]),
          _c("div", { staticClass: "more" }, [
            _vm._v(" " + _vm._s(_vm.value.config.more_name) + " "),
            _c("i", { staticClass: "el-icon el-icon-arrow-right" }),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.goodsList, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "product" },
              [
                item.movie_name
                  ? [
                      _c("el-image", {
                        staticClass: "img movie_img",
                        attrs: { src: item.thumb + "" },
                      }),
                      _c("div", { staticClass: "productName" }, [
                        _vm._v(" " + _vm._s(item.movie_name) + " "),
                      ]),
                      _c("div", { staticClass: "price movie" }, [
                        _vm._v(" " + _vm._s(item.publish_time) + " "),
                      ]),
                    ]
                  : [
                      _c("el-image", {
                        staticClass: "img",
                        attrs: { src: item.goods_thumb },
                      }),
                      _c("div", { staticClass: "productName" }, [
                        _vm._v(" " + _vm._s(item.goods_name) + " "),
                      ]),
                      item.shop_price
                        ? _c("div", { staticClass: "price" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("moneyFormat")(item.shop_price)) +
                                " " +
                                _vm._s(_vm.prepend) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ],
              ],
              2
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }